module.exports = __webpack_public_path__ + "img/heart_top_full.192158c4.png";